let turnUrl = "http://172.16.16.103:8091";

const websocketIDs = {
    loginId: 100,
    loginOutId: 101,
}
var websocketIsLogin = false;

export default {
    turnUrl,
    websocketIDs,
    websocketIsLogin
}
